import { useState, useEffect } from 'react';
import { buildJobsHub } from 'Components/SignalrSubscribes/signalRHubs';
import { useAuth } from 'Contexts/AuthProvider';
import { useBoxes } from 'Contexts/BoxContext';
import { useDispatch, useSelector } from 'react-redux';
import { setJobs } from 'Store/modules/dashboard/actions';
import dmsApiService from 'Services/DMS/dms-api.service';

const useJobSubscription = () => {
    const [hubConnection, setHubConnection] = useState(null);
    const { token } = useAuth();
    const [job, setJob] = useState(null);
    const { setUpdatedJob } = useBoxes();
    const dispatch = useDispatch();
    const currentCompany = useSelector((state) => state.dashboard.currentCompany);

    useEffect(() => {
        if (token) {
            const connection = buildJobsHub(token);
            setHubConnection(connection);

            let stopped = false;

            const startConnection = async () => {
                try {
                    await connection.start();
                    // console.log("Jobs hub connected...");
                } catch (err) {
                    // stop() during handshake rejects start() — expected on unmount/token change
                    if (!stopped) {
                        console.error("Error starting SignalR connection:", err);
                    }
                }
            };

            startConnection();

            return () => {
                stopped = true;
                if (connection) {
                    connection.stop().then(() => console.log("Jobs hub stopped..."));
                }
            };
        }
    }, [token]);

    const subscribeToJob = async (jobId, licenseId, onSuccess) => {
        if (!hubConnection || !jobId || !licenseId) {
            console.error("Hub connection, job ID, or license ID is missing.", {
                hubConnection: !!hubConnection,
                jobId,
                licenseId,
            });
            return false;
        }

        try {
            await hubConnection.invoke("SubscribeToJob", jobId, licenseId);
            if (onSuccess) onSuccess();
            const dataHandler = async (data) => {
                setJob(data);
                const response = await dmsApiService.getJobsShort();
                dispatch(setJobs(response));
                setUpdatedJob(data);
                // console.log('New job data received:', data);
            };

            hubConnection.on('NewJob', dataHandler);
            return true;
        } catch (err) {
            console.error("Error subscribing to job:", err);
            return false;
        }
    };

    return { hubConnection, subscribeToJob, job, setJob, currentCompany };
};

export default useJobSubscription;